<template>
  <div class="axj-main-menu">
    <axj-main-menu-item ref="menu" :data="item" :key="item.menuIcon" v-for="item in menuList">

    </axj-main-menu-item>
<!--    <div class="axj-main-menu-items" v-for="item in menuList">-->
<!--      <div class="axj-main-menu-items-title">-->
<!--        <label>{{item.menuTitle}}</label>-->
<!--      </div>-->
<!--      <div class="axj-main-menu-items-main">-->
<!--        <div class="axj-main-menu-items-main-item" v-for="child in item.children">-->
<!--          <label @click="handleJump(child)">{{ child.menuTitle }}</label>-->
<!--          <span class="icon"></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import AxjMainMenuItem from "./component/axj-main-menu-card/index";
export default {
  name: "axj-main-menu",
  components: {AxjMainMenuItem},
  data(){
    return{
      menuList:[{
        menuTitle:'资讯',
        menuIcon:"/axj_web_file/icon/axj-menu/zixun1.png",
        children:[{
          menuTitle:'校内',
          url:"/axjMain"
        },
        {
          menuTitle:'张贴',
          url:"/axjPost"
        },
        {
          menuTitle:'微站',
          url:"/axjStation"
        }
        ]
      },
      {
        menuTitle:'课外',
        menuIcon:"/axj_web_file/icon/axj-menu/kewai1.png",
        children:[{
          menuTitle:'秀吧',
          url:"/axjShowClub"
          },
          
          
          {
            menuTitle:'看吧',
            url:"/axjViewClub"
          },
          {
            menuTitle:'赛吧',
            url:"/axjCompetitionClub"
          }
          ]
        },
      {
          menuTitle:'助手',
        menuIcon:"/axj_web_file/icon/axj-menu/zhushou1.png",
          children:[
            {
              menuTitle:'课程',url:"/axjCourse"
            }
          ]
        },
      {
          menuTitle:'服务',
        menuIcon:"/axj_web_file/icon/axj-menu/fuwu1.png",
          children:[
            {
              menuTitle:'工作',url:'/axjWork'
            },
            {
              menuTitle:'健康',url:'/error'
            }
          ]
        }
      ]
    }
  },
  methods:{
    handleJump(child){
      this.$router.push({path:child.url})
    }
  },
  mounted() {

    let doc=document.querySelectorAll('.axj-main-menu-card')[0].querySelector('.axj-main-menu-card-menu')
    doc.querySelector('.axj-main-menu-card-menu-item-title-dot').style.visibility='visible'
    doc.querySelector('.axj-main-menu-card-menu-item-title-label').querySelector('label').style.color='#000000'
  }
}
</script>

<style slot-scope lang="scss">
.axj-main-menu{
  width: 981px;
  height: 140px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/axj-main/component/axj-main-menu/index.vue